module.exports = __webpack_public_path__ + "static/media/triangle.67086a9f.svg";